import _ from 'lodash';
import { INITIAL_STATE, LEGACY_GOODY_MAP } from '../../constants';

function legacyUser() {
	let legacyUserState = {};
	let parsedGoodies;
	let parsedVisits;
	let parseWorked;

	try {
		parsedGoodies = JSON.parse(window.localStorage.goodies);
		parsedVisits = JSON.parse(window.localStorage.visits);
		parseWorked = true;
	} catch (err) {
		console.error('Parsing window.localStorage.goodies failed with error: ', err);
		window.localStorage.setItem('failedStorageGoodies', window.localStorage.goodies);
		window.localStorage.setItem('failedStorageVisits', window.localStorage.visits);
	}

	if (parseWorked) {
		const { collected, unseen, shuffle, active } = parsedGoodies;

		const collectedGoodies = _.map(collected, goody => LEGACY_GOODY_MAP[goody]);

		const newCollectedGoodies = _.map(unseen, goody => LEGACY_GOODY_MAP[goody]);

		const activeGoodies = {
			hat: LEGACY_GOODY_MAP[active.hat],
			glasses: LEGACY_GOODY_MAP[active.glasses],
			toy: LEGACY_GOODY_MAP[active.toy],
		};

		const activeGoodiesShuffle = shuffle;

		legacyUserState = {
			...INITIAL_STATE,
			visits: parsedVisits,
			activeGoodies: {
				shuffle: activeGoodiesShuffle,
				active: activeGoodies,
			},
			collectedGoodies: {
				newItems: newCollectedGoodies,
				list: collectedGoodies,
			},
		};

	} else {
		legacyUserState = {
			...INITIAL_STATE,
		};
	}

	window.localStorage.setItem('tabbyCatVersion1', true);
	window.localStorage.removeItem('goodies');
	window.localStorage.removeItem('visits');

	return legacyUserState;
}

export default legacyUser;



// WEBPACK FOOTER //
// ./src/utils/getStorage/legacyUser.js